import type { FC } from "react";

import { AllowedProductProfileSearchForm } from "src/app/features/AllowedProductProfile/components/forms/AllowedProductProfileSearchForm";
import type { AllowedProductProfileList } from "src/app/features/AllowedProductProfile/types/AllowedProductProfileList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { AllowedProductsProfilesTable } from "../components/tables/AllowedProductsProfilesTable";

export const AllowedProductsProfilesPage: FC<NoneOwnProps> = () => {
    const table = <AllowedProductsProfilesTable />;
    const searchForm = <AllowedProductProfileSearchForm />;
    const hasAccess = canAccess(ResourceName.ALLOWED_PRODUCT_PROFILES, "canRead");

    return (
        <PageLayout name="allowedProductProfiles_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.allowedProductsProfiles" />
                    <ResourceManager<AllowedProductProfileList>
                        useDataGroup
                        dataMapperKey="allowedProductsProfileTableData"
                        resource={ResourceName.ALLOWED_PRODUCT_PROFILES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
